/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

module.exports = function getLocales(language, namespace, callback) {
  try {
    return callback(
      null,
      /* eslint-disable babel/func-params-comma-dangle, prefer-template */
      require("@auex/locales/lib/" + language + "/" + namespace + ".json5")
      /* eslint-enable babel/func-params-comma-dangle, prefer-template */
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return callback(null, {});
  }
};



// WEBPACK FOOTER //
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/locales/getLocales.js